import styled from 'styled-components';

export const HeaderPanelWrapper = styled.div`
  margin-bottom: 5px;
  background-color: #fff;
  position: relative;
  width: 100%;
`;
